module.exports = __webpack_public_path__ + "static/img/notpay.1e1ea3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notpay.png
// module id = BSAh
// module chunks = 3